interface Request {
  url: string;
  method: string;
  headers: string[];
  body: string;
}

interface Response {
  status: number;
  headers: string[];
  body: string;
}

interface LogError {
  code: string;
}

export enum LogLevel {
  INFO = 'INFO',
  ERROR = 'ERROR',
  DEBUG = 'DEBUG',
}

export interface HttpLog {
  id: string;
  request: Request;
  response: Response;
  error: LogError;
  requestType: string;
  level: LogLevel;
  duration: number;
  metadata: Map<string, string>;
  sentAt: string;
}
